
import useTranslation from 'providers/i18n/hooks/useTranslation';
import { UseAuthProps } from '../types';
import { AuthTemplatesProps } from '../../types';

const useAuthProps = ({ resetting, handleLoginSubmit, handleResetSubmit, goBackToLogin, handleOnClosePopup }: UseAuthProps) => {
  const { translate } = useTranslation();

  const authLayoutProps: { [key in 'reset' | 'login']: AuthTemplatesProps } = {
    login: {
      onSubmit: handleLoginSubmit,
      resetCallback: () => { },
      title: translate('account.sign.in'),
      headTitle: translate('account.account.login.signup'),
      buttonLabel: translate('account.sign.in'),
      onClose: handleOnClosePopup
    },
    reset: {
      onSubmit: handleResetSubmit,
      resetCallback: () => { },
      title: translate('account.password.reset.headline'),
      buttonLabel: translate('account.account.reset.link'),
      footerLinkLabel: translate('account.account.back.login'),
      footerLink: '/login',
      footerOnClick: goBackToLogin,
    },
  };
  return authLayoutProps[resetting ? 'reset' : 'login'];
};

export default useAuthProps;
